import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Dropdown from '../../../common/Dropdown';
import { getServiceRoute } from '../../../../services/serviceConfig';
import styles from './PageHeader.module.css';
import { ProfileDropdown } from 'components/common/ProfileDropdown/ProfileDropdown';
export const PageHeader = ({ title, onBackToHome, onToggleSidebar }) => {
  const navigate = useNavigate();
  const { serviceKey } = useParams();

  // Dashboard options for the dropdown
  const dashboardOptions = [
    { value: 'service-health', label: 'Service Health' },
    { value: 'cases', label: 'Incidents' },
    { value: 'changes', label: 'Changes' },
    { value: 'sla-reporting', label: 'SLA and Reporting' },
    { value: 'environment-performance', label: 'Service Requests' },
    // { value: 'alerts-aiops', label: 'Alerts and AIOps' },
    { value: 'problems-rca', label: 'Problems and RCA' },
    // { value: 'projects', label: 'Projects' },
    // { value: 'governance', label: 'Governance' }
  ];

  const handleDashboardChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      const route = getServiceRoute(selectedOption.value);
      if (route) {
        navigate(route);
      }
    }
  };

  return (
    <div className={styles.header}>
      <div className="Headermain">
        <div className="header-left">
          <div className='Headerlogo' onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
            <img src="https://kochasoft.com/assets/images/kochasoft-light.svg" alt="Brand Logo" />
          </div>
          <div className="portal-title">
            Customer Engagement Center
          </div>
        </div>
        <div className="header-right">
          <div className={styles.drowpdonwcus}>
            <div className={styles.dashboardSelector}>
              <Dropdown
                value={serviceKey}
                onChange={handleDashboardChange}
                options={dashboardOptions}
                placeholder="Select Dashboard"
                className={styles.customDropdown}
              />
            </div>
          </div>
          <div className="user-icon">
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumb: PropTypes.string.isRequired,
  onBackToHome: PropTypes.func.isRequired,
  onToggleSidebar: PropTypes.func
};
